import { FC, useEffect } from 'react';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Button, Stack } from '@optimus-web/core';
import { FloatingPanel } from '@mews/b2b-ui';
import { SectionList } from '@mews-commander/ui';
import { BillingAutomationChangesOrigin, useGainsightCommanderEvents } from '@mews-commander/utils';
import { AutomationIcon } from '../AutomationIcon';
import { RoutingConfirmationData } from './utils';

export interface RoutingRuleChangeConfirmationPanelProps extends RoutingConfirmationData {
    opened: boolean;
    onClose: () => void;
    onSubmit: () => void;
    origin: BillingAutomationChangesOrigin;
}

export const RoutingRuleChangeConfirmationPanel: FC<RoutingRuleChangeConfirmationPanelProps> = ({
    onClose,
    onSubmit,
    opened,
    items,
    sections,
    banner,
    typeOfChange,
    origin,
}) => {
    const gainsightEvents = useGainsightCommanderEvents();

    useEffect(() => {
        if (opened) {
            gainsightEvents.onElementView({
                context: 'BillingAutomationChanges',
                data: {
                    changes: typeOfChange,
                    origin,
                },
            });
        }
    }, [gainsightEvents, opened, origin, typeOfChange]);

    return (
        <FloatingPanel
            active={opened}
            modal={false}
            onClose={onClose}
            title={
                <>
                    {lt(TextKey.BillingWillBeAffected)} <AutomationIcon />
                </>
            }
            footer={{
                primary: (
                    <Button size="medium" variant="primary" onClick={onSubmit} type="submit">
                        {lt(TextKey.RoutingRuleMoveItems, { items })}
                    </Button>
                ),
                secondary: (
                    <Button size="medium" onClick={onClose} type="submit">
                        {lt(TextKey.GoBack)}
                    </Button>
                ),
            }}
        >
            <Stack vertical spacing="250">
                {banner && <Banner primaryText={banner.title} secondaryText={banner.subtitle} variant="warning" />}
                <SectionList sections={sections} />
            </Stack>
        </FloatingPanel>
    );
};
